const noncohesiveMoistures = ['Mało wilgotny', 'Wilgotny', 'Mokry'];

export default noncohesiveMoistures;